import axiosInstance from '../helpers/axiosInstance'

// wh1 Cubbitos receiving station (platform C2cReceivingController, PR #4335).
// Contract: docs/superpowers/specs/2026-09-08-cubbitos-c2c-receiving-screen-design.md §3.
// All three are JWT + Pundit; a permission/membership denial is a 403 that reaches the
// caller untouched (axiosInstance only intercepts 401).
const BASE = process.env.REACT_APP_PLATFORM_URL

// Bounded waits (review A11): the queue and the scan are interactive round-trips and get a
// 20s ceiling.
export const INTERACTIVE_TIMEOUT_MS = 20000
// The label call runs behind the platform's 2-minute generation lock and a carrier call can
// consume nearly all of it. A ceiling BELOW the lock turns a label the platform is still
// writing into a reported failure, so this sits just above it.
export const LABEL_TIMEOUT_MS = 130000
// The 409 retry runs AFTER a first attempt that may already have held the station for two
// minutes; the operator is standing at the printer. Half a minute is enough for a lock that
// has just been released.
export const LABEL_RETRY_TIMEOUT_MS = 30000

// The queue is an envelope, not a bare array (total/has_more make the 200-row cap
// visible). A drifted shape must surface as a query ERROR, never as an empty table.
const expectQueueEnvelope = data => {
  if (!data || !Array.isArray(data.orders)) throw new Error('Unexpected c2c/receiving/queue response shape')
  return data
}

// The scan and label envelopes are both `{ replayed, order, … }`. The order is what the
// pipeline keys everything on — the card, the strip entry (`order.id`), the reprint action —
// so a drifted shape has to fail loudly here instead of being papered over downstream with
// `result.order || order`, which would silently show and persist the REQUEST's order as if
// the platform had answered with it.
const hasOrder = data => !!data && typeof data.order === 'object' && data.order !== null && typeof data.order.id === 'number'

export const fetchC2cReceivingQueue = async (params = {}) => {
  const res = await axiosInstance.get(`${BASE}/api/v1/c2c/receiving/queue`, { params, timeout: INTERACTIVE_TIMEOUT_MS })
  return expectQueueEnvelope(res.data)
}

export const scanC2cRollCode = async ({ warehouse_id, roll_code }) => {
  const res = await axiosInstance.post(`${BASE}/api/v1/c2c/receiving/scan`, { warehouse_id, roll_code }, { timeout: INTERACTIVE_TIMEOUT_MS })
  if (!hasOrder(res.data)) throw new Error('Unexpected c2c/receiving/scan response shape')
  return res.data
}

export const generateC2cLabel = async (orderId, { warehouse_id }, { timeout = LABEL_TIMEOUT_MS } = {}) => {
  const res = await axiosInstance.post(`${BASE}/api/v1/c2c/receiving/orders/${orderId}/label`, { warehouse_id }, { timeout: timeout ?? LABEL_TIMEOUT_MS })
  if (!hasOrder(res.data) || !Array.isArray(res.data.shipping_labels)) throw new Error('Unexpected c2c/receiving/label response shape')
  return res.data
}
